import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrder, SearchQueryOrderDirection } from "types/generated";

export enum SPACE_POLICIES_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  INHERITED_FROM = "INHERITED_FROM",
  TYPE = "TYPE",
}

export const SPACE_POLICIES_COLUMNS_STORAGE_KEY = "spaceDetailsPoliciesColumnsConfig";
export const SPACE_POLICIES_LIMIT_STORAGE_KEY = "spaceDetailsPoliciesLimit";
export const SPACE_POLICIES_FILTERS_ORDER_KEY = "spaceDetailsPoliciesFiltersOrder";
export const SPACE_POLICIES_INITIAL_LIMIT = 50;

export const SPACE_POLICIES_COLUMN_CONFIG: Record<SPACE_POLICIES_COLUMN_ID, TableColumnMeta> = {
  [SPACE_POLICIES_COLUMN_ID.NAME]: {
    id: SPACE_POLICIES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_POLICIES_COLUMN_ID.TYPE]: {
    id: SPACE_POLICIES_COLUMN_ID.TYPE,
    title: "Type",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: 200,
    allowsSorting: true,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_POLICIES_COLUMN_ID.DESCRIPTION]: {
    id: SPACE_POLICIES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: 2000,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_POLICIES_COLUMN_ID.INHERITED_FROM]: {
    id: SPACE_POLICIES_COLUMN_ID.INHERITED_FROM,
    title: "Inherited from",
    tooltip: "Shows if a policy lives in this space or is inherited from a parent space.",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: 400,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
};

export const SPACE_POLICIES_SORT_CONFIG: Record<string, string> = {
  [SPACE_POLICIES_COLUMN_ID.NAME]: "name",
  [SPACE_POLICIES_COLUMN_ID.TYPE]: "type",
};

export const SPACE_POLICIES_INITIAL_ORDER_BY: SearchQueryOrder = {
  field: SPACE_POLICIES_SORT_CONFIG[SPACE_POLICIES_COLUMN_ID.NAME],
  direction: SearchQueryOrderDirection.Asc,
};
